import { render, staticRenderFns } from "./DialogEditFolder.vue?vue&type=template&id=6e2b7e93"
import script from "./DialogEditFolder.vue?vue&type=script&lang=js"
export * from "./DialogEditFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports